export const estadoDilucion = {
  DILUIDO: true,
  NO_DILUIDO: false
}

export const translateEstadoDilucion = {
  true: 'DILUIDO',
  false: 'NO_DILUIDO'
}